import React from "react";
import Card from "react-bootstrap/Card";
import { styleBlock } from "../styleBlock";
import iconStateNotOk from "../assets/icons/State/Not Ok.svg";
import iconStateOk from "../assets/icons/State/Ok.svg";
export default class AccountStatus extends React.PureComponent {
    render() {
        const { status, title, className, children } = this.props;
        const classNames = styleBlock("account-status");
        const cn = classNames({}).mix(className);
        return (React.createElement(Card, { className: cn.toString() },
            React.createElement(Card.Body, { className: "d-lg-flex flex-column align-items-center justify-content-center text-center", style: { padding: "15px" } },
                React.createElement("img", { width: "80", height: "80", className: "mb-4", draggable: false, src: status ? iconStateOk : iconStateNotOk, role: "presentation" }),
                React.createElement("h2", { className: "display-2 mb-2 font-weight-normal " + (status ? "text-success" : "text-danger"), dangerouslySetInnerHTML: { __html: title } }),
                React.createElement("div", { className: "font-size-md color-gray my-0" }, children))));
    }
}
//# sourceMappingURL=index.js.map